// extracted by mini-css-extract-plugin
export default {"PremierPromotionalMessage":"PremierPromotionalMessage_PremierPromotionalMessage"};